import { render, staticRenderFns } from "./WasteDetailDialog.vue?vue&type=template&id=694b0708&scoped=true&"
import script from "./WasteDetailDialog.vue?vue&type=script&lang=js&"
export * from "./WasteDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./WasteDetailDialog.vue?vue&type=style&index=0&id=694b0708&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694b0708",
  null
  
)

export default component.exports